import { useState } from "react";
import LegislationDetail from "../../LegislationList/LegislationDetail";

import "./index.css";


interface MatchedNotificationPagerProps {
    projects: number[]
}

export function MatchedProjectsNotificationPager({projects}: MatchedNotificationPagerProps) {

    const [currentProject, setCurrentProject] = useState(0);

    function prev() {
        if(currentProject > 0)
            setCurrentProject(currentProject - 1);
    }

    function next() {
        if((currentProject+1) < projects.length)
            setCurrentProject(currentProject + 1);
    }


    return (
        <>
            <div className="matched-pager-container">
                {
                    currentProject == 0? <div style={{width: 200}}></div> : <div role="button" className="button" onClick={() => prev()}>Proyecto Anterior</div>
                }
                <div>
                    <p>Proyecto {currentProject+1} de {projects.length}</p>
                </div>
                {
                    (currentProject+1) < projects.length? <div role="button" className="button" onClick={() => next()}>Pr&oacute;ximo Proyecto</div> : <div style={{width: 200}}></div>
                }
            </div>
            <LegislationDetail key={`matched_legislation_${projects[currentProject]}`} showNav={false} legislationId={projects[currentProject]} />
        </>
    );
}